import { Autocomplete, TextField, TextFieldVariants } from "@mui/material";
import useGlobalContext from "hooks/globalData";
import { useIntl } from "react-intl";
import { useQuery } from "react-query";
import { IdNameModel } from "services/KnowfullyAdminClient";

type SelectUserAgreementTypeMultipleProps = {
  value: string[];
  onChange: (v: string[]) => void;
  variant?: TextFieldVariants;
};

const SelectUserAgreementTypeMultiple = ({
  onChange,
  value,
  variant,
}: SelectUserAgreementTypeMultipleProps) => {
  const { skuUserAgreementService } = useGlobalContext();
  const { formatMessage: t } = useIntl();

  const { data, isFetching } = useQuery(["getSkuUserAgreementStatuses"], () =>
    skuUserAgreementService.getSkuUserAgreementStatuses()
  );

  const handleChangeMultiple = (_: any, values: IdNameModel[]) => {
    onChange(values.map((v) => v.id!));
  };

  const statuses =
    data?.data?.sort((a, b) => a.name!.localeCompare(b.name!)) ?? [];

  return (
    <Autocomplete
      multiple
      options={statuses}
      getOptionLabel={(option) => option.name ?? "?"}
      value={statuses.filter((r) => value.includes(r.id!) ?? false)}
      onChange={handleChangeMultiple}
      loading={isFetching}
      renderInput={(params) => (
        <TextField
          {...params}
          variant={variant}
          label={t({ id: "statusLabel" })}
        />
      )}
    />
  );
};

export default SelectUserAgreementTypeMultiple;
